<template>
    <div>
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <router-link class="breadcrumb-link" to="/fulfilment/">Fulfilment</router-link>  &gt;
                    <router-link class="breadcrumb-link" to="/fulfilment/inventory">Warehouse Products Inventory</router-link>
                </div>
                <h3>Warehouse Products Inventory</h3>
                <div class="ws-filter-links">
                    <div class="ws-filter-link" :class="'status-all '+(pageParams.filters.status.val?'':'active')">
                        <router-link to="/fulfilment/" event @click.native.prevent="setFilter('status',null)">All Products</router-link>
                        ({{ allProductsCount }})
                    </div>
                    <div class="ws-filter-link" v-for="status in index.meta.statuses" :class="'status-'+status.status+' '+(pageParams.filters.status.val==status.status?'active':'')">
                        <router-link :to="'/fulfilment?status='+status.status" event @click.native.prevent="setFilter('status',status.status)" >{{ status.status.replaceAll('-',' ') }}</router-link>
                        ({{ status.total }})
                    </div>
                </div>
            </div>
            <div class="ws-filters tw-flex tw-justify-end" style="margin-top: 27px;">
                <div class="ws-filter ws-filter-search">
                    <label>Search products</label>
                    <input type="text" v-model="pageParams.search.val" @keyup="setFilter(null)" placeholder="Search...">
                </div>
            </div>
        </div>

        <table id="list-of-warehouse-products"  class="worksends-table worksends-table-fulfilment">
            <thead>
            <tr>
                <th class="field-select"></th>
                <th class="field-id">
                    <div class="sortable" :class="sortClass('warehouse_id')" @click="sortBy('warehouse_id')">Product ID</div>
                </th>
                <th class="field-product">
                    <div class="sortable" :class="sortClass('name')" @click="sortBy('name')">Product Name & SKU</div>
                </th>
                <!--<th class="field-categories">Categories</th>-->
                <th class="field-status">Status</th>
                <th class="field-stock">
                    <div class="sortable" :class="sortClass('stock_level')" @click="sortBy('stock_level')">Stock Level</div>
                </th>
                <th class="field-actions">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in index.data" :class="item.selected?'selected':''">
                <td class="field-select">
                    <div class="row-select-box" @click="selectRow(item)"></div>
                </td>
                <td class="field-id" data-label="Product ID">
                    <b><a :href="'#'">#{{ item.warehouse_id }}</a></b>
                </td>
                <td class="field-product" data-label="Product">
                    <div class="product-image" :style="item.image_url?'background-image:url('+item.image_url+')':''" ></div>
                    <div class="product-name value"><b>{{ item.name }}</b></div>
                    <div class="product-sku"><b>SKU:</b> {{ item.sku }}</div>
                </td>
                <td class="field-product-status" data-label="Product Status">
                    <div :class="'status status-'+item.status">{{ item.status.replaceAll('-',' ') }}</div>
                </td>
                <td class="field-id" data-label="Product ID">
                    <b>{{ item.stock_level }}</b> units
                </td>
                <td class="field-actions" data-label="Actions">
                    <div class="ws-button small" @click="openWarehouseRequestModal(item)">WH Request</div>
                </td>
            </tr>
            </tbody>
        </table>
        <div ref="loadMore" v-show="!lazyLoading" v-if="index.meta.current_page < index.meta.last_page" class="ws-button ws-button-secondary small load-more-button" @click="loadMore">Load More...</div>
        <div class="loadable load-more-loader" v-show="lazyLoading"><div class="value-loader"></div></div>

        <div class="multi-action" v-if="selectedProductsCount">
            <div class="multi-action-summary">You have <b>{{ selectedProductsCount }}</b> out of <b>{{ index.meta.total }}</b> products selected.</div>
            <div class="multi-action-action">With selected: <div class="ws-button small" @click="openWarehouseRequestModal(null)">WH Request</div></div>
        </div>

        <warehouse-request-modal type="products" :items="requestItems" v-if="modals.whRequestModal"/>
    </div>
</template>

<script>
import WarehouseRequestModal from "@/components/modals/WarehouseRequestModal.vue";
import {isInViewport} from "@/utils/mixins";
import debounce from "lodash/debounce";
import moment from "moment/moment";

export default {
    name: "FulfilmentIndex",
    components: {WarehouseRequestModal},
    data: () => ({
        lazyLoading: false,
        requestItems: null,
        pageParams: {
            pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 30},
            search: {val: ""},
            filters: {
                status: { val: null, type: 'single' },
            }
        },
    }),
    methods: {
        async getPage(params = {}) {
            await this.getPageHandler({
                waitName: 'fulfilment.products',
                action: 'fetchWarehouseProducts', // vuex action
                pageParams: this.pageParams,
                isInit: params.init !== 'undefined' ? params.init : false, // parse from url query params
                pushRoute: params.pushRoute !== 'undefined' ? params.pushRoute : true, // push pagination params and search q to route
                resetPagination: params.resetPagination !== 'undefined' ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: params.routeParams !== 'undefined' ? params.routeParams : false, // extra params
                noWait: params.noWait !== 'undefined' ? params.noWait : false // extra params
            });
        },
        async setFilter(param = null, val = null) {
            if (param) this.pageParams.filters[param].val = val;
            await this.getPage({resetPagination: true});
        },
        async sortBy(field) {
            let copy = JSON.parse(JSON.stringify(this.pageParams.pageOptions)); // VUE reactivity hack https://github.com/vuejs/vue/issues/2164#issuecomment-377517724
            if (copy.sortBy[0] === field) {
                if (copy.sortDesc[0] === false) {
                    copy.sortBy = [];
                    copy.sortDesc = [];
                } else {
                    copy.sortDesc = [false];
                }
            } else {
                copy.sortBy = [field];
                copy.sortDesc = [true];
            }
            this.pageParams.pageOptions = copy;
            await this.getPage({resetPagination: true});
        },
        sortClass(field) { // pageOptions param just to be reactive
            if (this.pageParams.pageOptions.sortBy && this.pageParams.pageOptions.sortBy[0] === field) {
                return {'sort': true, 'sort-up': !this.pageParams.pageOptions.sortDesc[0], 'sort-down': this.pageParams.pageOptions.sortDesc[0]};
            }
            return {};
        },
        selectRow(item) {
            if (item.selected === 'undefined') item.selected = true;
            else item.selected = !item.selected;
        },
        async loadMore() {
            this.lazyLoading = true;
            this.pageParams.pageOptions.page = this.index.meta.current_page+1;

            await this.getPage({pushRoute: false, noWait: true, routeParams: {appendResults:true}});
            this.lazyLoading = false;
        },
        handleScroll() {
            if (this.index.meta.current_page < this.index.meta.last_page && isInViewport(this.$refs.loadMore,0) && !this.lazyLoading) {
                this.loadMore();
            }
        },
        openWarehouseRequestModal(item = null) {
            if (item) this.requestItems = [item];
            else if (this.selectedProductsCount)  this.requestItems = this.selectedProducts;
            else return;
            this.modals.whRequestModal = true;
        },
    },
    mounted() {
        //this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
        this.getPage({init:true});
        this.handleDebouncedScroll = debounce(this.handleScroll, 10);
        window.addEventListener('wheel', this.handleDebouncedScroll);
    },
    computed: {
        moment() {
            return moment
        },
        index() {
            return this.$store.state.warehouse.products;
        },
        modals() {
            return this.$store.state.modals;
        },
        allProductsCount() {
            const pluck = (arr, key) => arr.map(i => i[key]);
            if (this.index.meta.statuses) return pluck(this.index.meta.statuses, 'total').reduce((partialSum, a) => partialSum + a, 0);
            else return this.index.meta.total;
        },
        selectedProducts() {
            return this.index.data.filter(i => i.selected === true);
        },
        selectedProductsCount() {
            const pluck = (arr, key) => arr.map(i => i[key]);
            if (this.index.data) return pluck(this.index.data, 'selected').reduce((partialSum, a) => partialSum + (a===true?1:0), 0);
            else return 0;
        },
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.handleDebouncedScroll);
    },
}
</script>

<style scoped>
#list-of-warehouse-products .field-id {
    width: 100px;
}

#list-of-warehouse-products .field-product .product-image {
    float: left; 
    display: inline-block; 
    margin-right: 15px;
    width: 64px;
    height: 59px;
    border-radius: 5px;
    background-size: cover;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
}

#list-of-warehouse-products .field-product .product-name {
    font-size: 15px;
    margin-top: 8px;
}

#list-of-warehouse-products .field-product .product-sku {
    font-size: 12px;
}

</style>
